module.exports = __webpack_public_path__ + "static/img/khal_04.d487485.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/electronicDocuments/khal_04.png
// module id = PBeA
// module chunks = 2